/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Oidc_Brighten } from '../models/Oidc_Brighten';
import type { Oidc_Gsoa } from '../models/Oidc_Gsoa';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OidcService {
    /**
     * Login user
     * @returns any Successfully logged user. Return tokens from cdc sap and gsoa
     * @throws ApiError
     */
    public static responseLogin({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            /**
             * Code from SAP CDC
             */
            code: string;
            /**
             * Pkce code.
             */
            code_verifier: string;
        },
        apiVersion?: number,
    }): CancelablePromise<{
        brighten?: Oidc_Brighten;
        gsoa?: Oidc_Gsoa;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/oidc/response',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Either Invalid or Bad request`,
                401: `Unauthorized - invalid code`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Refresh CDC SAP a GSOA tokens
     * @returns any Successfully logged user. Return tokens from cdc sap and gsoa
     * @throws ApiError
     */
    public static refreshAccessToken({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            /**
             * Refresh token from CDC SAP system.
             */
            refresh_token: string;
        },
        apiVersion?: number,
    }): CancelablePromise<{
        brighten?: Oidc_Brighten;
        gsoa?: Oidc_Gsoa;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/oidc/refresh-access-token',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Either Invalid or Bad request`,
                401: `Unauthorized - invalid refresh token`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Invalidate bypass cache
     * @returns void
     * @throws ApiError
     */
    public static profileUpdate({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/oidc/profile-update',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                400: `Either Invalid or Bad request`,
                401: `Unauthorized - invalid access token`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Revoke refresh token
     * @returns void
     * @throws ApiError
     */
    public static revokeRefreshToken({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            /**
             * Refresh token from previous authentication.
             */
            refresh_token: string;
        },
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/oidc/revoke',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Either Invalid or Bad request`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Initialize OIDC authorization
     * @returns any Authorization URL and session ID
     * @throws ApiError
     */
    public static initAuthorize({
        apiVersion = 1,
        userState,
        redirectUrl,
        scopes,
        prompt,
    }: {
        apiVersion?: number,
        /**
         * User state for redirect after login
         */
        userState?: string,
        /**
         * Redirect uri for user
         */
        redirectUrl?: string,
        scopes?: Array<string>,
        /**
         * ussualy prompt is login
         */
        prompt?: string | null,
    }): CancelablePromise<{
        /**
         * URL to redirect user for OIDC login
         */
        authorize_url?: string;
        /**
         * Session identifier to use after callback
         */
        session_id?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/oidc/authorize',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'user_state': userState,
                'redirect_url': redirectUrl,
                'scopes': scopes,
                'prompt': prompt,
            },
        });
    }
    /**
     * OIDC callback endpoint
     * @returns void
     * @throws ApiError
     */
    public static oidcCallback({
        apiVersion = 1,
        code,
        state,
    }: {
        apiVersion?: number,
        code?: string,
        state?: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/oidc/callback',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'code': code,
                'state': state,
            },
            errors: {
                302: `Redirect to frontend with session_id`,
            },
        });
    }
    /**
     * Get session status and tokens
     * @returns any Session data
     * @throws ApiError
     */
    public static getSession({
        sessionId,
        apiVersion = 1,
    }: {
        sessionId: string,
        apiVersion?: number,
    }): CancelablePromise<{
        authenticated?: boolean;
        gsoa_access_token?: string;
        expires?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/oidc/session',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'session_id': sessionId,
            },
        });
    }
    /**
     * Refresh tokens using session ID
     * @returns any New tokens
     * @throws ApiError
     */
    public static refreshSessionToken({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        requestBody?: {
            session_id: string;
        },
    }): CancelablePromise<{
        gsoa_access_token?: string;
        expires?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/oidc/session/refresh',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Logout and invalidate session
     * @returns void
     * @throws ApiError
     */
    public static logoutSession({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/oidc/session/logout',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
}
